export const getPositionsForConfig = (config: any) => {
  let pos = 1;

  const positionen: {
    guid: undefined;
    position: number;
    artikelId: any;
    artikel: undefined;
    menge: number;
    beistellung: any;
  }[] = [];
  if (config.lsp3Selection?.items?.selectedLsp3Article?.artikelId) {
    // LSp3 Artikel einfügen
    positionen.push({
      guid: undefined,
      position: pos,
      artikelId: config.lsp3Selection?.items?.selectedLsp3Article?.artikelId,
      artikel: undefined,
      menge: 1,
      beistellung: false,
    });

    pos += 1;
  }

  if (config.lsp3Selection?.items?.selectedAbtriebszahnrad?.artikelId) {
    // Abtriebszahnrad einfügen
    positionen.push({
      guid: undefined,
      position: pos,
      artikelId:
        config.lsp3Selection?.items?.selectedAbtriebszahnrad?.artikelId,
      artikel: undefined,
      menge: 1,
      beistellung: false,
    });

    pos += 1;
  }

  if (config.lsp3Selection?.items?.selectedNuss?.artikelId) {
    // Nuss einfügen
    positionen.push({
      guid: undefined,
      position: pos,
      artikelId: config.lsp3Selection?.items?.selectedNuss?.artikelId,
      artikel: undefined,
      menge: 1,
      beistellung: false,
    });

    pos += 1;
  }

  if (config.lsp3Selection?.items?.selectedBit?.artikelId) {
    // Bit einfügen
    positionen.push({
      guid: undefined,
      position: pos,
      artikelId: config.lsp3Selection?.items?.selectedBit?.artikelId,
      artikel: undefined,
      menge: 1,
      beistellung: false,
    });

    pos += 1;
  }

  if (config.selectedAngleHead?.selectedAngleHead?.artikelId) {
    // Winkelkopf einfügen
    positionen.push({
      guid: undefined,
      position: pos,
      artikelId: config.selectedAngleHead?.selectedAngleHead?.artikelId,
      artikel: undefined,
      menge: 1,
      beistellung: false,
    });

    pos += 1;
  }

  if (
    config.selectedAngleHead?.selectedAngleHead?.artikelId &&
    config.selectedAngleHead?.selectedAngleHead?.artikelId == "P0000053"
  ) {
    // Es wurde ein WK nach Kundenspezifikation eingefügt. Daher muss das Antriebsset ausgetauscht werden. Außerdem ein Axial Adapter nach Kundenspezifikation
    positionen.push({
      guid: undefined,
      position: pos,
      artikelId: "P0000058", // Antriebsset nach Kundenspezifikation
      artikel: undefined,
      menge: 1,
      beistellung: false,
    });

    pos += 1;

    positionen.push({
      guid: undefined,
      position: pos,
      artikelId: "P0000057", // L.SP3 x-connect nach Kundenspezifikation
      artikel: undefined,
      menge: 1,
      beistellung: false,
    });

    pos += 1;
  } else if (config.selectedAntriebsset?.artikelId) {
    // Antriebsset einfügen
    positionen.push({
      guid: undefined,
      position: pos,
      artikelId: config.selectedAntriebsset?.artikelId,
      artikel: undefined,
      menge: 1,
      beistellung: false,
    });

    pos += 1;
  }

  if (config.lsp3Selection?.items?.selectedAntriebsmodul?.artikelId) {
    // Antriebsmodul einfügen
    positionen.push({
      guid: undefined,
      position: pos,
      artikelId: config.lsp3Selection?.items?.selectedAntriebsmodul?.artikelId,
      artikel: undefined,
      menge: 1,
      beistellung: false,
    });

    pos += 1;
  }

  if (config.lsp3Selection?.items?.selectedZwischenelement?.artikelId) {
    // Zwischenelement einfügen
    positionen.push({
      guid: undefined,
      position: pos,
      artikelId:
        config.lsp3Selection?.items?.selectedZwischenelement?.artikelId,
      artikel: undefined,
      menge: 1,
      beistellung: false,
    });

    pos += 1;
  }

  if (config.lsp3Connect?.selectedAdapter) {
    // Indexing Adapter einfügen
    positionen.push({
      guid: undefined,
      position: pos,
      artikelId: config.lsp3Connect?.selectedAdapter?.artikelId,
      artikel: undefined,
      menge: 1,
      beistellung: false,
    });

    pos += 1;
  }

  if (config.lsp3Connect?.reactionBar == true) {
    // Reactionbar nach Kundenanforderung einfügen
    positionen.push({
      guid: undefined,
      position: pos,
      artikelId: "P0000061",
      artikel: undefined,
      menge: 1,
      beistellung: false,
    });

    pos += 1;
  }

  if (config.lsp3Connect?.selectedZwischenelement) {
    // Zwischenelement einfügen
    positionen.push({
      guid: undefined,
      position: pos,
      artikelId: config.lsp3Connect?.selectedZwischenelement?.artikelId,
      artikel: undefined,
      menge: 1,
      beistellung: false,
    });

    pos += 1;
  }

  if (config.axialAdapter?.artikelId) {
    // Axial Adapter einfügen
    positionen.push({
      guid: undefined,
      position: pos,
      artikelId: config.axialAdapter?.artikelId,
      artikel: undefined,
      menge: 1,
      beistellung: false,
    });

    pos += 1;
  }

  if (config.tool?.tool?.artikelId) {
    // Tool einfügen
    positionen.push({
      guid: undefined,
      position: pos,
      artikelId: config.tool?.tool?.artikelId,
      artikel: undefined,
      menge: 1,
      beistellung: config.tool?.toolProvision,
    });

    pos += 1;

    // Tool Adapter hinzufügen
    if (config.tool?.adapter?.artikelId) {
      positionen.push({
        guid: undefined,
        position: pos,
        artikelId: config.tool?.adapter?.artikelId,
        artikel: undefined,
        menge: 1,
        beistellung: false,
      });
    } else {
      positionen.push({
        guid: undefined,
        position: pos,
        artikelId: "D0000100",
        artikel: undefined,
        menge: 1,
        beistellung: false,
      });
    }

    pos += 1;
  }

  if (config.service?.selectedMfu) {
    // Mfu hinzufügen
    positionen.push({
      guid: undefined,
      position: pos,
      artikelId: config.service?.selectedMfu,
      artikel: undefined,
      menge: 1,
      beistellung: false,
    });

    pos += 1;
  }

  if (config.service?.selectedRunningIn) {
    // Einlaufprotokoll hinzufügen
    positionen.push({
      guid: undefined,
      position: pos,
      artikelId: config.service?.selectedRunningIn,
      artikel: undefined,
      menge: 1,
      beistellung: false,
    });

    pos += 1;
  }

  return positionen;
};
